var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dialog-slot" },
    [
      _vm.modalBtn || _vm.allowEmptyBtnName
        ? _c(
            "button",
            {
              staticClass: "btn",
              class: _vm.modalBtnClass,
              attrs: { "data-reveal-id": _vm.id, disabled: _vm.disableBtn },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.handleOpenClick()
                },
              },
            },
            [_vm._v(_vm._s(_vm.modalBtn))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "dialogSlot",
          attrs: {
            modalId: _vm.id,
            showCloseBtn: _vm.showCloseBtn,
            beforeCloseModal: _vm.beforeCloseModal,
          },
        },
        [
          _vm.modalHeader
            ? _c("p", { staticClass: "modal-pure-text" }, [
                _vm._v(_vm._s(_vm.modalHeader)),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "content" }, slot: "content" },
            [_vm._t("content")],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "btns" }, slot: "btns" },
            [_vm._t("buttons")],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }